import "./TeamMemberCard.css";

const TeamMemberCard = ({ data }) => {
	const handleNavigation = (e, page) => {
		e.preventDefault();
		window.open(page, "_blank");
	};

	return (
		<div className="team-member-card-container" key={data["index"]}>
			<div className="card-team-member-image-container">
				<img
					alt={data["alt"]}
					src={require("../../assets/" + data["image"])}
					className="card-team-member-image"
				/>
			</div>
			<div className="empty-top"></div>
			<h3 className="h3-bold" style={{ margin: 0 }}>
				{data["name"]}
			</h3>
			<h4 style={{ margin: 0 }}>{data["title"]}</h4>
			<div className="horizonzal-line">
				<hr className="horizonzal-line-design" />
			</div>
			<h5 style={{ margin: 0 }}>{data["position"]}</h5>
			<div className="card-team-member-icons">
				{data["techStack"].map(function (icon, index) {
					return (
						<div
							className="card-team-member-icon-container"
							key={index}
							title={icon["label"]}
							onClick={(e) => handleNavigation(e, icon["url"])}
						>
							<img
								alt={icon["label"]}
								src={require("../../assets/" + icon["image"])}
								className="card-team-member-icon-image"
							/>
						</div>
					);
				})}
			</div>
			<div className="empty-bottom"></div>
		</div>
	);
};

export default TeamMemberCard;
